import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const CheckShape = ({
  width = 24,
  height = 24,
  fillColor = 'none',
  strokeColor = '#000000',
  strokeWidth = 2,
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 12.6111L8.92308 17.5L20 6.5"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckShape;
